import Cookies from "js-cookie";
// cookie保存的天数
import config from "@/config";

import moment from "moment";

const { title, cookieExpires, useI18n } = config;

export const TOKEN_KEY = "emshop_token";

export const setToken = token => {
  Cookies.set(TOKEN_KEY, token, { expires: cookieExpires || 1 });
};

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY);
  if (token) return token;
  else return false;
};

export const setCookie = (key, value) => {
  Cookies.set(key, value, { expires: cookieExpires || 1 });
};

export const getCookie = key => {
  const value = Cookies.get(key);
  if (value) return value;
  else return "";
};

export const setStorage = (key, value) => {
  localStorage[key] = value;
};
export const getStorage = key => {
  return localStorage[key];
};

export const hasChild = item => {
  return item.children && item.children.length !== 0;
};

/**
 * 计算已过时间
 */

export const durationInfo = (time, duration) => {
  let created_at = moment(time);
  let currentTime = new Date();
  let now = moment(currentTime);
  // let end = created_at.add(duration, 'minutes');
  let retInfo;
  let passMinutus = now.diff(created_at, "minute");
  if (passMinutus < duration) {
    if (passMinutus < 60) {
      retInfo = { info: "已过" + passMinutus + "分钟", code: 200 };
    } else {
      let hours = parseInt(passMinutus / 60);
      if (hours < 24) {
        retInfo = { info: "已过" + hours + "小时", code: 200 };
      } else {
        let days = paserInt(hours / 24);
        retInfo = { info: "已过" + days + "天", code: 200 };
      }
    }
  } else {
    let minutePassed = passMinutus - duration;
    if (minutePassed > 60) {
      let hours = parseInt(minutePassed / 60);
      if (hours > 24) {
        let days = parseInt(hours / 24);
        retInfo = { info: "已超" + days + "天", code: 201, color: "red" };
      } else {
        retInfo = {
          info: "已超" + hours + "小时",
          code: 201,
          color: "yellow"
        };
      }
    } else {
      retInfo = {
        info: "已超" + (passMinutus - duration) + "分钟",
        code: 201,
        color: "blue"
      };
    }
  }

  return retInfo;
};

export const procTimeInfo = (begintime, endtime) => {
  let created_at = moment(begintime);
  let finished_at = moment(endtime);
  let passMinutus = finished_at.diff(created_at, "minute");
  let retInfo = { info: passMinutus + "分钟", code: 200 };
  //   console.log(begintime,endtime, passMinutus);
  return retInfo;
};

export const Coding = (codeFlag, codeData) => {
  let codeString = codeData.format;

  codeString = codeString.replace("{code}", codeFlag);
  codeString = codeString.replace("{year}", codeData.year);
  codeString = codeString.replace("{month}", codeData.month);
  codeString = codeString.replace("{day}", codeData.day);
  codeString = codeString.replace("{serial}", codeData.value);

  return codeString;
};

export const fMoney = money => {
  var num = new Number(money);
  let ret = num.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  return ret;
};

export const loadcssfile = filename => {
  var fileref = document.createElement("link");
  fileref.setAttribute("rel", "stylesheet");
  fileref.setAttribute("type", "text/css");
  fileref.setAttribute("href", filename);
  if (typeof fileref != "undefined") {
    document.getElementsByTagName("head")[0].appendChild(fileref);
  }
};
